// 漫画広告（/ads/manga）の単一の正となる定数。
//
// ページ数の選択肢と表示比率はフロント各所（生成フォーム・完了ギャラリー・
// 生成中プレビュー・公開ページ）に散らばっていたので、ここへ集約する。
// backend 側の上限は MangaProject::MIN_PAGES / MAX_PAGES（2〜12）。

/** ページ数セレクトの選択肢。backend の min:2|max:12 と揃えること。 */
export const MANGA_PAGE_COUNT_OPTIONS = [2, 4, 6, 8, 10, 12] as const;

/** CTA ボタン文言の既定値。backend の createProject 側の既定と揃えること。 */
export const MANGA_DEFAULT_CTA_TEXT = '詳しく見る';

/** 漫画ページの生成比率。backend の aspect_ratio バリデーションと同じ集合。 */
export type MangaAspectRatio = '1:1' | '9:16' | '16:9';

/**
 * aspect_ratio に対応する Tailwind のアスペクト比クラスを返す。
 *
 * purge 対策のため、必ず完全なクラス名文字列を返す（動的生成禁止）。
 * 未設定・未知の値は既定の 1:1（スクエア）として扱う。
 */
export const mangaAspectClass = (aspectRatio?: string | null): string => {
  switch (aspectRatio) {
    case '9:16':
      return 'aspect-[9/16]';
    case '16:9':
      return 'aspect-video';
    case '1:1':
    default:
      return 'aspect-square';
  }
};

// --- 公開設定パネルと生成タブで共用する Tailwind クラス定数 ---
// 旧 MangaGenerationTab.scss のユーティリティ化分のうち、MangaPublicationPanel へ
// 切り出した部分でも使うものをここへ移した（同じ文字列を 2 箇所に持たないため）。
// purge 対策のため、必ず完全なクラス名文字列で保持すること（動的生成禁止）。

export const MANGA_BTN_PRIMARY_BASE =
  'inline-flex cursor-pointer items-center justify-center gap-2 rounded-lg bg-indigo-500 font-semibold text-white transition-all duration-200 hover:enabled:bg-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-300';
export const MANGA_BTN_PRIMARY_SM = `${MANGA_BTN_PRIMARY_BASE} px-4 py-2 text-[13px]`;

export const MANGA_BTN_SECONDARY_BASE =
  'inline-flex cursor-pointer items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white font-medium text-gray-700 transition-all duration-200 hover:enabled:border-gray-400 hover:enabled:bg-gray-100 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:opacity-60';
export const MANGA_BTN_SECONDARY_SM = `${MANGA_BTN_SECONDARY_BASE} px-4 py-2 text-[13px]`;

export const MANGA_FIELD_FOCUS =
  'focus:border-indigo-500 focus:shadow-[0_0_0_3px_rgba(99,102,241,0.1)] focus:outline-none';
export const MANGA_INPUT = `w-full rounded-lg border border-gray-300 px-4 py-3 text-sm transition-all duration-200 ${MANGA_FIELD_FOCUS}`;

// .manga-setup-form .manga-form-setting .manga-form-label（margin-bottom のみ 4px）
export const MANGA_SETTING_LABEL = 'mb-1 block text-sm font-medium text-gray-700';
